import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    benefitId: Number,
    confirmMark: String
  }

  connect() {
    this.row = this.element.closest("tr")
    if (!this.row) return
    this.benefitIdInput = this.row.querySelector("input[name='benefit_ids[]']")
    this.deleteInputName = `benefit_delete[${this.benefitIdValue}]`
    this.actionsCell = this.row.querySelector("td.align-middle.text-center:last-child")
    this.ensureIconOnly(this.element)
    const isMarked = this.row.classList.contains("benefit-row-pending-delete")
    this.updateButton(isMarked)
    this.updateDeleteInput()
  }

  toggle(event) {
    event.preventDefault()
    if (!this.row) return
    const wasMarked = this.row.classList.contains("benefit-row-pending-delete")
    const willMark = !wasMarked
    if (willMark && this.confirmMarkValue && !window.confirm(this.confirmMarkValue)) return
    const isMarked = this.row.classList.toggle("benefit-row-pending-delete")
    this.updateDeleteInput()
    this.updateBenefitIdInput(isMarked)
    this.updateButton(isMarked)
  }

  updateDeleteInput() {
    const existing = this.row.querySelector(`input[name='${this.deleteInputName}']`)
    const isMarked = this.row.classList.contains("benefit-row-pending-delete")
    if (isMarked && !existing && this.actionsCell) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.deleteInputName
      input.value = "1"
      this.actionsCell.appendChild(input)
    }
    if (!isMarked && existing) existing.remove()
  }

  updateBenefitIdInput(isMarked) {
    if (!this.benefitIdInput) return
    if (isMarked) {
      this.benefitIdInput.disabled = true
      this.benefitIdInput.name = "benefit_ids_ignored[]"
    } else {
      this.benefitIdInput.disabled = false
      this.benefitIdInput.name = "benefit_ids[]"
    }
  }

  updateButton(isMarked) {
    const btn = this.element
    this.ensureIconOnly(btn)
    const icon = btn.querySelector("i")
    if (isMarked) {
      if (icon) {
        icon.classList.remove("fa-trash")
        icon.classList.add("fa-undo")
      }
      btn.classList.remove("btn-outline-danger")
      btn.classList.add("btn-outline-secondary")
      btn.title = "Restore"
      btn.setAttribute("aria-label", "Restore")
    } else {
      if (icon) {
        icon.classList.remove("fa-undo")
        icon.classList.add("fa-trash")
      }
      btn.classList.remove("btn-outline-secondary")
      btn.classList.add("btn-outline-danger")
      btn.title = "Mark for deletion"
      btn.setAttribute("aria-label", "Mark for deletion")
    }
  }

  ensureIconOnly(btn) {
    Array.from(btn.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) node.remove()
    })
    let icon = btn.querySelector("i")
    if (!icon) {
      icon = document.createElement("i")
      icon.setAttribute("aria-hidden", "true")
      icon.classList.add("fas")
      btn.appendChild(icon)
    }
  }
}
